import React from "react";

export const AuthInput = ({
  label,
  type = "text",
  name,
  value,
  onChange,
  placeholder,
  error,
  isPassword = false,
  togglePasswordVisibility,
  passwordVisible,
  dark = false,
}) => (
  <div className="flex flex-col gap-1.5 mt-4">
    <label className="text-sm font-medium" style={dark ? { color: 'rgba(255,255,255,0.7)' } : { color: '#374151' }}>{label}</label>
    <div className="relative">
      <input
        type={isPassword && passwordVisible ? "text" : type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={dark ? {
          background: 'rgba(255,255,255,0.08)',
          border: `1px solid ${error ? 'rgba(248,113,113,0.6)' : 'rgba(255,255,255,0.15)'}`,
          color: 'rgba(255,255,255,0.9)',
        } : {}}
        className={`w-full rounded-xl border px-4 py-2.5 text-sm outline-none transition-all duration-150
          ${dark
            ? `placeholder-white/30 ${isPassword ? "pr-10" : ""}`
            : `text-gray-900 placeholder-gray-400 bg-white ${error
                ? "border-red-400 focus:border-red-400 focus:ring-2 focus:ring-red-100"
                : "border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
              } ${isPassword ? "pr-10" : ""}`
          }`}
      />
      {isPassword && (
        <button
          type="button"
          onClick={togglePasswordVisibility}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
          tabIndex={-1}
        >
          <img
            src={passwordVisible ? "/images/icons/noEye.svg" : "/images/icons/eye.svg"}
            alt="toggle visibility"
            className="w-4 h-4"
          />
        </button>
      )}
    </div>
    {error && (
      <p className="text-xs text-red-500 flex items-start gap-1 mt-0.5">
        <img src="/images/icons/error.svg" className="w-3 h-3 mt-0.5 flex-shrink-0" alt="" />
        {error}
      </p>
    )}
  </div>
);
